import { api } from "./client";
import type {
  MasterAcademicYear,
  MasterCategory,
  MasterFaculty,
  MasterSemester,
  MasterStudyProgram,
  MasterUnit,
} from "./types";

/** Data master untuk mengisi dropdown formulir. */

export function listCategories() {
  return api.get<{ items: MasterCategory[] }>("/master/categories");
}

export function listAcademicYears() {
  return api.get<{ items: MasterAcademicYear[] }>("/master/academic-years");
}

export function listSemesters() {
  return api.get<{ items: MasterSemester[] }>("/master/semesters");
}

export function listFaculties() {
  return api.get<{ items: MasterFaculty[] }>("/master/faculties");
}

export function listStudyPrograms() {
  return api.get<{ items: MasterStudyProgram[] }>("/master/study-programs");
}

export function listUnits() {
  return api.get<{ items: MasterUnit[] }>("/master/units");
}

export function listEvidenceTypes() {
  return api.get<{ items: string[] }>("/master/evidence-types");
}
